/* W72 step 6 — THE TWO INBOX SURFACES THAT WAIT ON HIS WORD, and the one place that may name them.
 *
 * 🔴 `coach_message_reactions` (a table) and `coach-voice` (a private bucket) are NEW SECURITY SURFACE and HIS
 * (`LAUNCH.md` §6, the SECURITY row dated 2026-09-25 ~00:45). Both are written and rehearsed under
 * `tools/w72-inbox-policies/` and NEITHER IS LIVE. The screens that use them are BUILT anyway, so the day he says
 * go nothing is rebuilt — and each one asks the database at runtime whether its surface exists before it draws a
 * single control (`probeReactions`, `probeVoice`). Absent = the control is not drawn; a probe that fails for any
 * reason fails CLOSED.
 *
 * ⚠️ THE ONE UNTYPED DOOR, AND WHY IT IS HERE AND NOWHERE ELSE. The generated types describe the LIVE database
 * (the codex: "editing it to make a query compile is how it stops doing so"), and the live database has no
 * reactions table, so `supabase.from("coach_message_reactions")` does not compile. The door is cast ONCE, below,
 * and the harness gate `w72-6` asserts no other file under `web/src` names either surface. The day the table is
 * live: regenerate `database.types.ts`, delete the cast, and the compiler checks every column named here.
 */
import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "../lib/supabase";

export const reactionsTable = "coach_message_reactions";
export const voiceBucket = "coach-voice";

const untyped = supabase as unknown as SupabaseClient;

/** The reactions table, untyped until it is live (see the header). */
export function reactionsFrom() {
  return untyped.from(reactionsTable);
}

/**
 * Does the reactions table exist and admit this coach? One row, one column; ANY error is "no" — a missing table is
 * PostgREST's `PGRST205`, a refused one `42501`, and both mean the chips must not be drawn.
 */
export async function probeReactions(): Promise<boolean> {
  try {
    const { error } = await reactionsFrom().select("message_id").limit(1);
    return error === null;
  } catch {
    return false;
  }
}

/**
 * Does the `coach-voice` bucket exist? Listing the coach's OWN folder (lowercased — the 2026-09-12 lesson) answers
 * `Bucket not found` while the bucket is absent and an empty list once it exists; ANY error is "no".
 */
export async function probeVoice(coachId: string): Promise<boolean> {
  try {
    const { error } = await supabase.storage.from(voiceBucket).list(coachId.toLowerCase(), { limit: 1 });
    return error === null;
  } catch {
    return false;
  }
}
